// Friendly dead-end for a group the current account can't load — a stale
// link, a deleted group, or someone else's group id. Without this, pages
// rendered a fake "No transactions yet" empty state and users could think
// their data was deleted (UAT finding, July 2026).
import { Link } from 'react-router-dom'
import { AlertTriangle } from 'lucide-react'

export default function GroupNotFound() {
  return (
    <div className="card text-center py-12 max-w-md mx-auto mt-8">
      <AlertTriangle size={28} className="text-amber-400 mx-auto mb-4" />
      <p className="font-display text-xl text-ink-100 mb-2">
        This group doesn't exist or you don't have access
      </p>
      <p className="text-sm text-ink-400 mb-5">
        The link may be old, or the group may belong to a different account.
      </p>
      <Link to="/groups" className="btn-primary inline-flex">Back to Groups</Link>
    </div>
  )
}
